<template>
    <inertia-link
        :href="href"
        :class="isActive ? 'bg-gray-900 text-white' : 'text-gray-400'"
        class="group flex items-center px-2 py-2 text-sm leading-6 font-medium rounded-md hover:text-white hover:bg-gray-900 focus:outline-none focus:bg-gray-900 transition"
    >
        <span class="rounded-md p-1 mr-3" :class="[iconBgColor]">
            <icon :name="icon" class-icon="h-5 w-5" :class="[iconColor, isActive ? 'opacity-100' : 'opacity-60']"
                  :fill="iconFill"/>
        </span>
        <slot/>
    </inertia-link>
</template>

<script>
export default {
    name: 'NavigationLink',

    props: {
        href: {
            type: String,
            required: true
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        params: {
            type: Object,
            default: () => {}
        },
        icon: {
            type: String,
            default: 'arrow-circle-right'
        },
        iconColor: {
            type: String,
            default: 'text-white'
        },
        iconFill: {
            type: String,
            default: 'rgba(255,255,255,0.3)'
        },
        iconBgFrom: {
            type: String,
            default: ''
        },
        iconBgTo: {
            type: String,
            default: ''
        },
        exact: {
            type: Boolean,
            default: false
        },
    },

    computed: {
        iconBgColor() {
            if (this.iconBgFrom !== '' && this.iconBgTo !== '') {
                return `bg-gradient-to-r ${this.iconBgFrom} ${this.iconBgTo}`
            }

            return 'bg-gray-700';
        }
    },
}
</script>
